import { Common } from "../../../utils";
import { axiosBasic } from "../../../api/axios";
import { config } from "../../../api/endPoints";
import { GET_SPECIFIC_BOOKMARK, IS_LOADING, LIKE_UP } from "./postActionsTypes";

const { UserBookmarks, LikedBookmarks } = config.REST_API;
const {ROOT_URL_Version_1}=config;
export const isLoading = value => ({
  type: IS_LOADING,
  payload: value
});

export const specificBookmark = data => ({
  type: GET_SPECIFIC_BOOKMARK,
  payload: data
});

export const increaseLike = like => ({
  type: LIKE_UP,
  payload: like
});

export const onGetSpecificBookmark = bookmarkId => dispatch => {
  dispatch(isLoading(true));
  let queryString = "?" + "bookmarkId=" + bookmarkId+"&webId=18";
  axiosBasic
    .get(ROOT_URL_Version_1+UserBookmarks.GetSpecificBookmark + queryString)
    .then(response => {
      const { success, data, message } = response.data;
      if (success) {
        dispatch(specificBookmark(data.bookmark));
      } else {
        Common.showErrorMessage(message);
      }
    })
    .catch(error => {
      Common.showErrorMessage(error);
    })
    .finally(() => {
      dispatch(isLoading(false));
    });
};

export const likeUp = bookmarkId => dispatch => {
  dispatch(isLoading(true));
  let queryString = "?" + "bookmarkId=" + bookmarkId;
  axiosBasic
    .post(ROOT_URL_Version_1+LikedBookmarks.LikeUp + queryString)
    .then(response => {
      const { success, data, message } = response.data;
      if (success) {
        dispatch(increaseLike(data));
      } else {
        Common.showInfoMessage(message);
      }
    })
    .catch(error => {
      Common.showErrorMessage(error);
    })
    .finally(() => {
      dispatch(isLoading(false));
    });
};
